<div
    class="flex h-full min-h-0 w-full max-h-full flex-col divide-y divide-gray-100 dark:divide-white/10 overflow-hidden shadow-card-container-pale">
    <div class="shrink-0 p-2 flex flex-row flex-wrap items-center justify-between gap-2">
        <div class="flex min-w-0 items-center flex-1">
            <div class="shrink-0">
                <div
                    class="size-10 rounded-xl bg-green-500/20 text-green-500 text-sm font-semibold flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-6">
                        <path
                            d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2" />
                    </svg>
                </div>
            </div>
            <div class="ml-4 min-w-0">
                <h3 class="text-md font-semibold text-primary">Recent Activity</h3>
                <p class="hidden text-sm text-secondary sm:block">
                    Across all briefs.
                </p>
            </div>
        </div>

        <el-select id="select" name="selected" class="block">
            <button type="button" class="btn-fab-secondary text-secondary">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5">
                    <path
                        d="M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z" />
                </svg>
            </button>

            <el-options anchor="bottom start" popover
                class="max-h-60 w-56 overflow-auto rounded-md bg-white py-1 text-base shadow-lg outline-1 outline-black/5 [--anchor-gap:--spacing(1)] data-leave:transition data-leave:transition-discrete data-leave:duration-100 data-leave:ease-in data-closed:data-leave:opacity-0 sm:text-sm dark:bg-gray-800 dark:shadow-none dark:-outline-offset-1 dark:outline-white/10">
                @for (status of selectableActivityStatuses; track status) {
                <el-option [value]="status" (click)="filterStatus(status)"
                    class="group/option relative flex flex-row items-center justify-between cursor-default py-2 pr-3 pl-3 text-gray-900 select-none focus:bg-indigo-600 focus:text-white focus:outline-hidden dark:text-white dark:focus:bg-indigo-500">
                    <span class="block truncate font-normal group-aria-selected/option:font-semibold">{{
                        getStatusLabel(status) }}</span>
                    @if (visibleStatuses().indexOf(status) > -1) {
                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true" class="size-5">
                        <path
                            d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                            clip-rule="evenodd" fill-rule="evenodd" />
                    </svg>
                    }
                </el-option>
                }
            </el-options>
        </el-select>


    </div>
    <div class="flex min-h-0 flex-1 flex-col overflow-hidden px-2 py-2">
        @if (statusHistory() && statusHistory()!.length > 0) {
        <div #scrollContainer class="min-h-0 flex-1 overflow-y-auto scrollbar-transparent" infinite-scroll
            [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="scrollThrottle"
            [infiniteScrollContainer]="scrollContainer" [infiniteScrollDisabled]="!hasMore() || isLoadingMore()"
            (scrolled)="onScrollDown()">
            <ul role="list" class="divide-y divide-gray-100 dark:divide-white/10">
                @for (application of statusHistory(); track $index) {
                @if (application && application.creator) {
                <li (click)="onApplicationClick(application)"
                    class="flex justify-between gap-x-6 py-3 hover:bg-indigo-50 dark:hover:bg-indigo-900/50 hover:cursor-pointer">
                    <div class="flex min-w-0 gap-x-4">
                        <img class="w-12 h-12 rounded-lg"
                            [src]="imageService.getImageSource(application.creator.photoURL ?? '', 'gallery')" h="12"
                            w="12" alt="">
                        <div class="min-w-0 flex-auto">
                            <p class="text-sm font-semibold leading-6 text-primary">{{
                                application.creator.firstName
                                }} {{
                                application.creator.lastName.charAt(0)
                                }}</p>
                            <p class="mt-1 truncate text-xs leading-5 text-secondary">{{
                                application.brief.title
                                }}</p>
                        </div>
                    </div>
                    <div class="flex shrink-0 flex-col items-end">
                        <atom-application-status-badge
                            [applicationStatus]="application.applicationStatus"></atom-application-status-badge>
                        <p class="mt-1 text-xs leading-5 text-secondary">{{
                            formatService.getTimeSinceUpdated(application.createdDate)
                            }}</p>
                    </div>
                </li>
                }
                }
            </ul>
            @if (isLoadingMore()) {
            <ul class="flex flex-col divide-y divide-gray-100 dark:divide-white/10" aria-hidden="true"
                aria-busy="true">
                @for (row of skeletonRows; track row) {
                <li class="relative overflow-hidden flex flex-row items-center gap-x-3 px-2 py-2.5">
                    <div class="shrink-0 size-12 rounded-lg bg-gray-200 dark:bg-white/10"></div>
                    <div class="min-w-0 flex-1 space-y-2">
                        <div class="h-3 w-1/2 rounded-full bg-gray-200 dark:bg-white/10"></div>
                        <div class="h-2 w-3/4 rounded-full bg-gray-200 dark:bg-white/10"></div>
                    </div>
                    <div class="hidden shrink-0 sm:flex sm:flex-col sm:items-end sm:gap-y-2">
                        <div class="h-5 w-16 rounded-full bg-gray-200 dark:bg-white/10"></div>
                        <div class="h-2 w-12 rounded-full bg-gray-200 dark:bg-white/10"></div>
                    </div>
                    <div class="skeleton-shimmer"></div>
                </li>
                }
            </ul>
            }
        </div>
        }
        @else if (statusHistory() && statusHistory()!.length == 0) {
        <div class="w-full flex flex-col items-center justify-center p-4 h-full">
            <div class="text-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="mx-auto size-12 text-gray-400 dark:text-gray-500">
                    <path
                        d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2" />
                </svg>
                <h3 class="mt-2 text-sm font-semibold text-primary">Quiet times</h3>
                <p class="mt-1 text-sm text-secondary">There's no recent activity to show.</p>

            </div>
        </div>
        } @else {
        <div class="h-full w-full">
            <ul class="flex flex-col divide-y divide-gray-100 dark:divide-white/10" aria-hidden="true"
                aria-busy="true">
                @for (row of skeletonRows; track row) {
                <li class="relative overflow-hidden flex flex-row items-center gap-x-3 px-2 py-2.5">
                    <div class="shrink-0 size-12 rounded-lg bg-gray-200 dark:bg-white/10"></div>
                    <div class="min-w-0 flex-1 space-y-2">
                        <div class="h-3 w-1/2 rounded-full bg-gray-200 dark:bg-white/10"></div>
                        <div class="h-2 w-3/4 rounded-full bg-gray-200 dark:bg-white/10"></div>
                    </div>
                    <div class="hidden shrink-0 sm:flex sm:flex-col sm:items-end sm:gap-y-2">
                        <div class="h-5 w-16 rounded-full bg-gray-200 dark:bg-white/10"></div>
                        <div class="h-2 w-12 rounded-full bg-gray-200 dark:bg-white/10"></div>
                    </div>
                    <div class="skeleton-shimmer"></div>
                </li>
                }
            </ul>
        </div>
        }
    </div>
</div>